import { useInRecordSection } from 'components/section-edit/SectionEdit';
import React from 'react';

type Props = {
    children: React.ReactNode;
};

/**
 * Renders children in a 2-column grid on desktop, single column on mobile.
 * Use to place short form fields (e.g. first name + last name) side by side.
 *
 * The single column is the grid collapsing at the breakpoint, not a second branch: a media query
 * read in JS would decide it one render late, and the fields would jump on the first paint.
 *
 * In a record section the row steps aside: each field is a cell of the section's own grid, where the read view
 * has its row.
 */
const FormRow = ({ children }: Props) => (
    <div
        data-slot="form-row"
        className={useInRecordSection() ? 'contents' : 'grid w-full grid-cols-1 gap-4 sm:grid-cols-2'}
    >
        {children}
    </div>
);

export default FormRow;
